var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 15.25C5.75 14.6977 6.19772 14.25 6.75 14.25H8.75C9.30228 14.25 9.75 14.6977 9.75 15.25V18.75H6.75C6.19772 18.75 5.75 18.3023 5.75 17.75V15.25Z",
    stroke: "#7236CD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.75C9.75 10.1977 10.1977 9.75 10.75 9.75H12.75C13.3023 9.75 13.75 10.1977 13.75 10.75V18.75H9.75V10.75Z",
    stroke: "#7236CD",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 6.25C13.75 5.69772 14.1977 5.25 14.75 5.25H16.75C17.3023 5.25 17.75 5.69772 17.75 6.25V17.75C17.75 18.3023 17.3023 18.75 16.75 18.75H13.75V6.25Z",
    stroke: "#7236CD",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.203d7197d5141d9349d8848b4ef632b7.svg";
export { ForwardRef as ReactComponent };